export const uk = {
    'audience-and-metrika': 'Яндекс.Аудитории и Яндекс.Метрика',
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    'copy-link': 'Копировать настройки группы в буфер обмена',
    ots: 'OTS',
    'predictor-settings': 'Настройки группы объявлений',
    'reach-title': 'Показы',
    'reach-title-ots': 'Охват аудитории'
};
